// @ts-nocheck
import React, { useContext, useEffect, useRef, useState } from "react";
import BuyFlow from "./components/buy-flow";
import { howToBuy, useBundles } from "./components/data";
import AuthContext from "/context/AuthProvider";
import state from "/redux/state";
import { useWithdrawableBalance } from "/api/user/tico-balance";
import { useAxiosWithAuth } from "/utils/hooks/useAxiosAPI";
import CustomButton from "/components/core/ButtonDefault";
import { ConfirmPopup } from "./components/Popups";
import { Link } from "react-router-dom";
import { loadHubSpot } from "/utils/utils";
import BundlesSlider from "./components/bundles-slider";

export default function Bundles() {
  const setSlide = useState(0);
  const [activeIndex] = setSlide;
  const [buyCount, setBuyCount] = useState({});
  const { auth } = useContext(AuthContext);
  const axiosClient = useAxiosWithAuth();
  const { data } = useWithdrawableBalance(axiosClient);
  const ticoBalance = Number(data?.ticoBalance || 0);

  const bundles = useBundles();

  const activeBundle = bundles[activeIndex];
  const bundleCount = buyCount[activeBundle.uuid] || 1;

  const changeValue = (count) => {
    setBuyCount((prev) => ({
      ...prev,
      [activeBundle.uuid]: bundleCount + count,
    }));
  };

  const handleConfirm = () => {
    if (!auth?.token) {
      state.setPopUp("login");
      return;
    }
    state.setPopUp("data", {
      custom: () => (
        <ConfirmPopup
          shopItemId={activeBundle.uuid}
          item={activeBundle}
          price={activeBundle.price}
          priceCurrency={"tico"}
          quantity={bundleCount}
        />
      ),
    });
  };

  return (
    <section className="bundles">
      <div className="wrapper df fd-c ai-c w-full pd-lr-md">
        <div className="wrapper-title text-shadow">
          <p>
            Use the <span className="gradient">Funtico Fan Tickets</span> for
            exclusive access to our sports-themed game events!
          </p>
        </div>

        <div className="wrapper-content">
          {/* <BundlesSlider
            bundles={bundles}
            buyCount={buyCount}
            setSlide={setSlide}
          /> */}

          <div
            className={`wrapper-information df fd-c ai-c block ${bundles.length > 1 ? "" : "bundle-single"}`}
          >
            <div className="contains df fd-c ai-c">
              {/* =============== OLD PART */}
              {/* <p className="font-20-blk">CONTAINS:</p>
                  <div className="list-wrapper">
                    {bundles.map((bundle, index) => (
                      <div
                        className={`list ${index === activeIndex ? "active" : ""}`}
                        key={bundle.uuid}
                      >
                        {bundle.data.map((item) => (
                          <div className="item df ai-c" key={item.name}>
                            <p>{item.name}</p>
                            <div className="line"></div>
                            <img src={item.icon} alt={item.name} />
                          </div>
                        ))}
                      </div>
                    ))}
                  </div> */}
              <p className="title font-20-blk">{activeBundle.name}</p>
              <div className="bundle-visual df fit-cover w-full">
                <img src={activeBundle.visual} alt={activeBundle.name} />
              </div>
            </div>
            <BuyFlow
              value={bundleCount}
              setValue={changeValue}
              price={activeBundle.price}
              handleBuy={handleConfirm}
              TICO_USDT={activeBundle.usd}
              ticoBalance={auth?.token ? ticoBalance : 9999999999999999}
            />
          </div>
          <div className="wrapper-issues df fd-c">
            <div className="how-to-buy df fd-c ai-c fixel_16_bl block">
              <p className="title font-20-blk uppercase">Need to buy $TICO? </p>
              <div className="how df">
                {howToBuy.map((item, id) => {
                  const name = item.name.replace("<br>", "");

                  return (
                    <React.Fragment key={name}>
                      {id !== 0 && <div className="line"></div>}

                      {item.link ? (
                        <Link to={item.link} className="item df ai-c">
                          <img src={item.icon} alt={name} />
                          <p
                            dangerouslySetInnerHTML={{ __html: item.name }}
                          ></p>
                          <div className="open icon_blank_wh"></div>
                        </Link>
                      ) : (
                        <CustomButton
                          className="item df ai-c"
                          onClick={() =>
                            !auth?.token
                              ? state.setPopUp("login")
                              : state.setShowWallet(true)
                          }
                        >
                          <img src={item.icon} alt={name} />
                          <p
                            dangerouslySetInnerHTML={{ __html: item.name }}
                          ></p>
                          <div className="open icon_blank_wh"></div>
                        </CustomButton>
                      )}
                    </React.Fragment>
                  );
                })}
              </div>

              <p className="explainer">
                ** Fees may apply when you deposit with credit card
              </p>
            </div>

            <div className="issues block df fd-c text-center">
              <p className="font-20-blk uppercase">ISSUES?</p>
              <p className="subtitle font-20-sbl">
                If none of the above worked, please talk with our LIVE support
                now!
              </p>

              <button
                className="def cta pr as-c type-40 br-16 fixel_16_bl"
                onClick={loadHubSpot}
              >
                CONTACT US
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
